export default {
  data () {
    return {
      value: '',
      isAutocompleteClick: false
    }
  },

  props: {
    type: {
      type: String
    },

    listOfficialModels: {
      type: Array
    }
  },

  watch: {
    model (val) {
      this.value = val
    }
  },

  mounted () {
    this.value = this.model
  },

  methods: {
    hideAutocomplete () {
      setTimeout(() => {
        this.$emit('set-autocomplete:model', {
          hide: true
        })
      }, 500)
    },

    setAutocompleteModel () {
      this.$emit('set-autocomplete:model', {
        show: true,
        left: this.left,
        top: this.top,
        model: this.value,
        fieldId: this.id,
        type: this.type,
        page: this.$store.state.fileCurrentPage
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/editor.js